module.exports = __webpack_public_path__ + "common/tp-featured9-d372dbd226b5889e3a7430265926ee1e.svg";